import { autocompleteSearch } from './autocomplete-search';
import $ from 'jquery';
import 'jquery-ui-autocomplete';

const initAutocomplete = (partnerId) => {
  const $mainMenuItems = $('#main-menu-items');
  const $mainMenuSearchResult = $('#main-menu-search-result, #mega-menu-search-result');
  const $mainMenuSearchForm = $('#main-menu-search-form');

  const $autocomplete = $(document).find('.ui-autocomplete-input').autocomplete({
    appendTo: '#main-menu-search-result, #mega-menu-search-result',
    open: () => {
      // Remove unwanted styles when results are opened
      $mainMenuSearchResult.find('.ui-autocomplete').attr('style', '');
    },
    select: (event, ui) => {
      // Set value of search input to selected item and submit form to navigate to search page
      $mainMenuSearchForm.find('input[name=q]').val(ui.item.value);
      $mainMenuSearchForm.submit();
    },
    source: (request, response) => {
      autocompleteSearch(request.term, partnerId).then((responses) => {
        response(responses);
        if (responses.length > 0) {
          $mainMenuItems.hide();
          $mainMenuSearchResult.show();
        }
      }, () => {
        response([]);
      });
    },
  });

  // Override default rendering of items
  $autocomplete.data('ui-autocomplete')._renderItem = (ul, item) => {
    return $('<li>')
      .html(`<a href="#">${item.value}</a>`)
      .appendTo(ul);
  };

  // On empty input, hide search result and show menu
  $autocomplete.on('input', () => {
    if (!$autocomplete.val()) {
      $mainMenuItems.show();
      $mainMenuSearchResult.hide();
    }
  });
};

export { initAutocomplete };
